import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IOption } from './IOption';
import { IQuery } from './IQuery';

@Component({
    selector: 'app-navigation-query',
    styleUrls: ['./navigation-query.component.scss'],
    templateUrl: './navigation-query.component.html',
    standalone: false
})
export class NavigationQueryComponent implements OnInit {

  @Input() public query: IQuery;
  @Input() public queryIndex = 0;
  @ViewChild(forwardRef(()=>NavigationQueryComponent)) public child: NavigationQueryComponent;
  public root: UntypedFormGroup;
  public selectedOption: IOption;
  private optionSelect: UntypedFormControl;

  constructor(private fb: UntypedFormBuilder) { }

  public ngOnInit() {
    this.optionSelect = new UntypedFormControl('');
    this.root = this.fb.group({ option: this.optionSelect });
    this.optionSelect.valueChanges.subscribe((value: string) => {
      if (this.child) {
        this.child.clearSelectedOption();
      }
      this.setOption(value);
    });
  }

  public clearSelectedOption(): void {
    this.selectedOption = undefined;
    this.optionSelect.setValue('');
  }

  private setOption(optValue: string): void {
    this.selectedOption = this.query.options.find((opt: IOption) => opt.text === optValue);
  }

}
